function ResearchRequestForm(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */

	
	/* PRIVATE VARIABLES */
	var submitEnabled = true;
	var form;
	var recaptchaToken = null;


	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	
	

	function showAlert(message) {
		alert(message);
	}


	function onFormSendSuccess(data){
		$('.state.form', _this.container).hide();
		$('.state.success', _this.container).show();

		_this.resetForm();
	}	
	
	
	function reinitializeForm(){
		$('.state.form', _this.container).show();
		$('.state.success', _this.container).hide();
		submitEnabled = true;
	}


	function onFormSendError(errorCode){
		switch(errorCode) {
			case 1:
				// captcha
				showAlert('Chyba ověření reCAPTCHA kódu. Zkuste prosím znovu načíst stránku a odeslat formulář.');
				break;

			default:
				// default
				showAlert('Odeslání formuláře se nezdařilo. Zkuste to prosím znovu později.');
				break;
		}
		/*
		getRecaptchaToken();
		*/
	}


	function initFormHandler(){
		var messageFieldInvalid = 'Vyplňte prosím toto pole.';
		var messageFieldEmail = 'Vyplňte prosím e-mailovou adresu ve správném tvaru.';
		var messageFieldYear = 'Vyplňte prosím rok.';

		form.validate({
			messages: {
				topic: {
					required: messageFieldInvalid
				},
				year_from: {
					number: messageFieldYear,
					min: messageFieldYear,
					max: messageFieldYear,
				},
				year_to: {
					number: messageFieldYear,
					min: messageFieldYear,
					max: messageFieldYear,
				},
				name: {
					required: messageFieldInvalid
				},
				email: {
					required: messageFieldEmail,
					email: messageFieldEmail
				},
			},

			submitHandler: function(f) {
				if(submitEnabled){
					submitEnabled = false;
					var url = form.attr('action');
					var data = form.serializeArray();
					data.push({name: "formAction", value: "submit"});
					data.push({name: "recaptchaToken", value: recaptchaToken});

					$.post(url, data, function(result){
						if(result.status === 1){
							onFormSendSuccess(data);
						} else {
							onFormSendError(result.errorCode);
							submitEnabled = true;
						}
					});
				}
			}
		});
	}


	function getRecaptchaToken(){
		grecaptcha.execute(recaptchaSiteKey, {action: 'research_request_form'})
		.then(function (token) {
			recaptchaToken = token;
		});
	}


	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			// object references
			form = $('form', _this.container);
			
			// handlers
			$('.button.newRequest', _this.container).click(function(e) {
				e.preventDefault();
				reinitializeForm();
			});
			
			// init
			initFormHandler();
			
			/*
			grecaptcha.ready(function () {
				getRecaptchaToken();
			});
			*/
			
			_this.inited = true;
		}
	};
	
	
	this.resetForm = function(){
		form[0].reset();
	};
	

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
